import { gql } from '@apollo/client';
import { Locale } from '../../../../localization/LocalizationKeys';
import { siteFieldConfig } from '../../person/fields/utils/personFieldsUtils';
import {
  EntityTypeEnum,
  FieldEnum,
  SiteCriteriaOrder,
  UpdateSiteNumberOfChairsMutationMutationVariables
} from '../../../../gql/typings';
import { buildNumberUpdateFieldConfig } from '../../../components/FieldConfig/buildNumberUpdateFieldConfig';

export const siteNumberOfChairsFieldConfig = siteFieldConfig(
  'numberOfChairs',
  [
    'id',
    'numberOfChairs',
    'controlSetting.id',
    'controlSetting.entityTypeId',
    'controlSetting.maintainerSourceCode',
    'controlSetting.createDcr',
  ],
  ({ localization }) => ({
    sorting: {
      ascend: SiteCriteriaOrder.NUMBER_OF_CHAIRS_ASC,
      descend: SiteCriteriaOrder.NUMBER_OF_CHAIRS_DESC,
    },
    title: localization.formatMessage(Locale.Attribute.Number_of_chairs),
    additionalTableConfig: {
      width: 80
    },
    dcrInfo: (site) => ({
      entityType: EntityTypeEnum.SITE,
      entityAffiliationId: site.id,
      field: FieldEnum.HCO_NUMBER_OF_CHAIRS,
    }),
    render: (site) => site.numberOfChairs ?? '',
    updateView: buildNumberUpdateFieldConfig({
      mutation: UPDATE_SITE_NUMBER_OF_CHAIRS_MUTATION,
      valuePath: 'numberOfChairs',
      buildVariables: (value, record) => ({
        siteId: record.id,
        chairs: value,
      }) as UpdateSiteNumberOfChairsMutationMutationVariables,
    }),
  }),
);

const UPDATE_SITE_NUMBER_OF_CHAIRS_MUTATION = gql`
  mutation UpdateSiteNumberOfChairsMutation($siteId: Int!, $chairs: Int) {
    updateSiteNumberOfChairs(siteId: $siteId, numberOfChairs: $chairs) {
      id
      numberOfChairs
    }
  }
`;
